import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=78164eea&scoped=true&"
import script from "./Press.vue?vue&type=script&lang=ts&"
export * from "./Press.vue?vue&type=script&lang=ts&"
import style0 from "./Press.vue?vue&type=style&index=0&id=78164eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78164eea",
  null
  
)

export default component.exports